import { announcementCvBase64 } from './announcementManagement';
export function announcementCvFile(response) {
  const content = response?.data;
  let bytes;
  if (content?.type === 'Buffer' && Array.isArray(content.data)) bytes = Uint8Array.from(content.data);
  else {
    const base64 = announcementCvBase64(content);
    if (!base64) throw new Error('Aucun fichier CV disponible pour cette candidature.');
    try { bytes = Uint8Array.from(atob(base64), char => char.charCodeAt(0)); }
    catch { throw new Error('Le fichier CV reçu est invalide.'); }
  }
  const header=Array.from(bytes.slice(0,5)).map(value=>String.fromCharCode(value)).join('');
  const mime=header==='%PDF-'?'application/pdf':bytes[0]===0xff&&bytes[1]===0xd8?'image/jpeg':bytes[0]===0x89&&header.slice(1,4)==='PNG'?'image/png':null;
  if(!mime) throw new Error('Ce CV n’est pas un PDF ou une image consultable. Téléversez une version PDF dans la fiche candidat.');
  return {blob:new Blob([bytes],{type:mime}),mime};
}
